import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import * as React from "react";
import { Input, Label } from "uxp/components";
import { hasValue, parseValue } from "../../../../util";
import { IBaseFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import IconEditor, { generateIconProp } from "../../icon-selector/IconEditor";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
import './statistic.scss';
interface IStatisticFieldProperties extends IBaseFieldProperty {
	label: string;
    units: string;
    value: string;
    icon: string;
	color: string;
	size: string;
}

export const Field: React.FunctionComponent<IUIFieldProps<IStatisticFieldProperties>> = (props) => {

	let {label,units,value,icon,color,size } = props.fieldProps || {}
	if (!color) {
		color = '#424242';
	}
	let sizePx = '40px';
	let s = Number(size);
	if (s) {
		sizePx =s + 'px';
	}
	let styles: React.CSSProperties = {}
	

	return (
		<div className={classNames('ui-field', props.mode)} >
            <div className='ui-field-statistic' style={{fontSize:sizePx}}>
                <div className='icon' style={{backgroundColor:parseValue(color, props.contextData)}}>
                    <FontAwesomeIcon color="white" icon={generateIconProp(icon)} />
                </div>
                <div className='txt' style={{color: parseValue(color, props.contextData)}}>
                    <div className='label'>{label}</div>
                    <div className='content'>
                        <div className='value'>{value}</div>
                        <div className='units'>{units}</div>
                    </div>
                </div>
            </div>
		</div >
	)
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IStatisticFieldProperties>> = (props) => {
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Statistic</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Label</PropertyTitle>
				<Input
					value={props.uiProps.label || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { label: s }))}
				/>
			</Property>
            <Property>
				<PropertyTitle>Value</PropertyTitle>
				<Input
					value={props.uiProps.value || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
				/>
			</Property>
            <Property>
				<PropertyTitle>Units</PropertyTitle>
				<Input
					value={props.uiProps.units || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { units: s }))}
				/>
			</Property>
			<Property>
				<PropertyTitle>Color</PropertyTitle>
				<CustomColorPicker contextData={props.contextData} color={props.uiProps.color||'#424242'} 
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { color: s }))}
					/>

			</Property>
			<Property>
				<PropertyTitle>Size</PropertyTitle>
				<Input
					value={props.uiProps.size || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { size: s }))}
				/>
			</Property>

            <Property>
				<PropertyTitle>Icon</PropertyTitle>
                <IconEditor
                            value={props.uiProps.icon || ''}
                            onChange={s => props.onChange(Object.assign({}, props.uiProps, { icon: s }))
                            }
                        />
			</Property>
		

		</PropertyGroup>

	</PropertyContainer>;
}
registerUIField({
	id: 'statistic',
	description: 'Statistic',
	field: Field,
	propertyEditor: PropertyEditor,
	defaultProps: {
        value: '666',
        label:'My Stat',
        units:'kwh',
        icon:'lightbulb',
		color:'#424242',
		size:'40',
	}

});


